/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLeadIsValid = exports.saveLead = exports.clearLead = exports.saveEnv = exports.Ui = exports.Model = exports.Configuration = void 0;

var api_1 = require("./api");

Object.defineProperty(exports, "Configuration", {
  enumerable: true,
  get: function get() {
    return api_1.Configuration;
  }
});
Object.defineProperty(exports, "Model", {
  enumerable: true,
  get: function get() {
    return api_1.Model;
  }
});

var app_1 = require("./app");

Object.defineProperty(exports, "saveEnv", {
  enumerable: true,
  get: function get() {
    return app_1.saveEnv;
  }
});

var leads_1 = require("./leads");

Object.defineProperty(exports, "clearLead", {
  enumerable: true,
  get: function get() {
    return leads_1.clearLead;
  }
});
Object.defineProperty(exports, "saveLead", {
  enumerable: true,
  get: function get() {
    return leads_1.saveLead;
  }
});
Object.defineProperty(exports, "setLeadIsValid", {
  enumerable: true,
  get: function get() {
    return leads_1.setLeadIsValid;
  }
});

var ui_1 = require("./ui");

Object.defineProperty(exports, "Ui", {
  enumerable: true,
  get: function get() {
    return ui_1.Ui;
  }
});